import { useGetLazyPaginatedSKUs } from "./useGetLazyPaginatedSKUs";

export const useSKUsTableRows = () => {
  const { data, loading } = useGetLazyPaginatedSKUs();

  const rows =
    data?.getSKUs?.items
      .map((item, index) => {
        return {
          id: item?.id,
          rowId: item?.id ?? `${index}`,
          skuNumber: item?.skuNumber,
          configurationName: item?.configurationName,
          category: item?.category,
          nodeCount: item?.nodeCount,
          skuDataConfigurations: item?.skuDataConfigurations,
          createdAt: item?.createdAt,
          defaultIp: item?.defaultIp,
        };
      })
      .sort((a, b) => (b?.createdAt ?? 0) - (a?.createdAt ?? 0)) ?? [];

  return { rows, loading };
};
